import { ReactNode } from "react";

type ButtonProps = {
  onClick: () => void;
  children: ReactNode;
  ariaLabel?: string;
  className?: string;
};

export const Button = ({ 
  onClick, 
  children,
  ariaLabel,
  className = "",
}: ButtonProps) => (
  <button
    onClick={onClick}
    aria-label={ariaLabel}
    className={`w-full h-[58px] rounded-md bg-white border-2 border-black text-black text-[22px] tracking-[1.76px] active:bg-black active:text-white transition-all flex items-center justify-center ${className}`}
  >
    {children}
  </button>
);

export default Button;